$(function() {
    // set up forgot password modal
    var forgotPasswordForm = $("#newForgotPasswordForm"); // $("#forgotPasswordForm");
    var overlayClose;
    var validation = $(".validation");
    validation.hide();

    forgotPasswordForm.hide();


    var forgotPassword = $("#whitepaperForgotPass");
    forgotPassword.on("click", function(event){
      event.preventDefault();

      forgotPasswordForm.find("validation").hide();

      forgotPasswordForm.modal('show');
      /*
      var modal = forgotPasswordForm.modal({
        focus: false,
        overlayId: "signInSignUpOverlay",
        opacity: 70,
        close: true,
        closeHTML: "<span></span>",
        closeClass: "signInSignUpClose",
        overlayClose: true,
        persist: true,
        autoResize: true,
        onShow: function() {
          overlayClose = $(".signInSignUpClose");
        },
        onClose: function() { 
          validation.hide();
          $.modal.close();
        }
      });
      */
      forgotPasswordForm.find(".validation").hide();
    });
    
    $("#newForgotPasswordForm .rememberPassword").on("click", function(event){
      event.preventDefault();
      forgotPasswordForm.find(".validation").hide();
      forgotPasswordForm.modal('hide');
    });
    
//    forgotPasswordForm.on('hidden.bs.modal', function (e) {
//      forgotPasswordForm.validation.hide();
//    })

    // ajax validation
    $("#user-forgot-password-form").on("submit", function(event){
      event.preventDefault();
      var $this = $(this),
        inputs = $this.find("input"),
        submit = inputs.filter("input[type=submit]"),
        loading = $this.find(".loading"),
        validation = $this.find(".validation").empty().hide();

      if ($this.valid()) {
        var email = $('#user-current-email').val();
        grecaptcha.ready(function() {
          grecaptcha.execute(grecaptchav3_sitekey, {action: 'forgot_password'}).then(function(token) {

            $.ajax({
              type: "POST",
              url: $this.attr("action"),
              data: {"user-current-email": email, "token": token},
              beforeSend: function() {
                loading.show();
                inputs.attr("disabled", "disabled");
              },
              success: function(data) {
                if (data.errors) {
                  console.log(data.errors);
                  $.each(data.errors, function(key, value) {
                    validation.append($("<p></p>").text(value))
                  });
                  validation.show();
                } else if (data.displayLoginForm) {
                  registrationForm.hide();
                  $("#lhuser").val(inputs.filter("input[type=email]").val());
                  loginForm
                      .show()
                      .find(".validation")
                          .html($("<p></p>").text(data.message))
                          .show();
                } else if (data.message) {
                  validation
                      .html($("<p></p>").html(data.message))
                      .show();
                } else if (data.captcha) {
                  captchaValidation
                      .html($("<p></p>").text(data.captcha))
                      .show();
                }
                if (data.redirect) {
                  setTimeout(function() {
                    window.location.replace(data.redirect);
                  }, 1500);
                } else {
                  loading.hide();
                  inputs.prop("disabled", false);

                  if (data.reload) {
                    setTimeout(function() {
                      window.location.reload();
                    }, 1500);
                  }
                }
              },
              error: function(data) {
                if (data.errors) {
                  console.log(data.errors);
                  $.each(data.errors, function(key, value) {
                    validation.append($("<p></p>").text(value))
                  });
                  validation.show();
                }
              }
            });
        
          });
        });
      }
    });

    $(".user-registration-form").validate({"errorClass":"invalid","meta":"validate"});
  });
